import React, { FC } from 'react';
import { Card, Container } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { DashboardHeader } from 'src/UIKit/DashboardHeader';
import { Select } from 'src/UIKit/Select';
import { observer } from 'mobx-react-lite';
import { CategoryImageDropZone } from '../components/categoryImageDropZone';
import { TextInput } from 'src/UIKit/TextInput';
import { useNewsCategoryCreating } from '../../presenters/useNewsCategoryCreating';

export const NewsCategoryCreatingView: FC = observer(() => {
    const { t } = useUiContext();
    const { category, errors, onChange, onCreateCategory } = useNewsCategoryCreating();

    return (
        <Container maxWidth="xl">
            <DashboardHeader title={t('editNewsCategory')} buttonTitle={t('save')} onPress={onCreateCategory} />
            <CategoryImageDropZone />
            <Card sx={{ p: 2, mb: 2 }}>
                <TextInput label={t('name')} name='name' onChange={onChange} value={category?.name} error={errors} required />
                <TextInput label={t('description')} name='description' onChange={onChange} value={category?.description} />
                <TextInput label={t('slug')} name='slug' onChange={onChange} value={category?.slug} error={errors} required />
            </Card>
        </Container>
    );
})
